import { FTLDowntimeT } from '../types/ftl.types'

export const FTL_TYPES = [
    {
        id: '0',
        name: 'Междугородняя перевозка',
    },
    {
        id: '1',
        name: 'Международная перевозка',
    },
]

export const FTL_TYPES_EXTENDED = [
    {
        id: '0',
        name: 'Междугородняя перевозка',
    },
    {
        id: '1',
        name: 'Международная перевозка',
    },
    {
        id: '2',
        name: 'Внутригородская перевозка'
    }
]

export const FT_CREATE_TYPES = [
    {
        id: '0',
        name: 'Междугородняя перевозка',
    },
    {
        id: '1',
        name: 'Международная перевозка',
    },
    {
        id: '2',
        name: 'Внутригородская перевозка',
    },
]

export const FTL_CUSTOMS_CLEARANCE_TYPES = [
    {
        id: null,
        name: 'Не выбрано',
    },
    {
        id: '0',
        name: 'Нет таможенного оформления',
    },
    {
        id: '1',
        name: 'Есть таможенное оформление',
    },
]

export const STATUSES = [
    { id: 1, name: 'Рассчитывается стоимость' },
    { id: 3, name: 'Согласован' },
    { id: 4, name: 'Отменен' },
    { id: 5, name: 'Создан' },
    { id: 7, name: 'На согласовании' },
    { id: 8, name: 'Внесены данные о перевозчике' },
    { id: 9, name: 'Завершен' },
]

export const FTL_PAYMENT_RATE_TYPES = [
    { id: 1, name: 'За час' },
    { id: 2, name: 'За рейс' },
]

export const FTL_ORDER_PAYMENT_RATE_TYPES = [
    { id: 1, name: 'За рейс' },
    { id: 2, name: 'За час' },
]

export const EMPTY_DOWNTIME: FTLDowntimeT | null = {
    type: 1,
    hours: null,
    cost_price: null,
    paid_price: null,
}
